module.exports = __webpack_public_path__ + "media/icons/etoile_moitie-47285093.svg";